import React, { useEffect, useState } from "react";
import { Avatar, Divider, Flex, Popover, Tag, Tooltip } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import { ExtraSmallTitle, Title4 } from "components/Common/Typography/Titles";
import JobTitleList from "components/CandidateCard/JobTitles";
import npiIcon from "../../images/npi.png";
import ProfileLogo from "../../Icon/sincureCircleLogo.png";

import verifiedtick from "../../images/verifiedtick.svg";
import { SvgIcons } from "Icon/SvgIcons";
import TooltipWrapper from "./TooltipWrapper";
interface DynamicObject {
  [key: string]: any; // This allows any string as a key and any type as a value
}

interface CandidateInfoCardProps {
  candidateNotes: any;
  name: string | undefined;
  profilePic: string | undefined;
  location: string | undefined;
  title: string | undefined;
  workExperience?: DynamicObject;
  licenses: any;
  npi: any;
  editedTooltip?: boolean;
  toolTipText?: any;
}

const CandidateInfoCard: React.FC<CandidateInfoCardProps> = ({
  candidateNotes,
  name,
  profilePic,
  location,
  title,
  workExperience = [],
  npi,
  licenses,
  editedTooltip,
  toolTipText,
}) => {
  const jobTitles = workExperience?.map((title: DynamicObject) => ({
    id: title?.id,
    designation: title?.designation,
  }));

  console.log("ToolTip Title: ", toolTipText?.title);
  const content = (
    <div>
      {licenses &&
        licenses.map((license: any, index: number) => (
          <React.Fragment key={index}>
            <p>{license.name}</p>
            <p>{license.date_added}</p>
            <p>{license.license_number}</p>
            <b>{license.verified ? "Verified" : "Not Verified"}</b>
            <Divider className="my-1" />
          </React.Fragment>
        ))}
    </div>
  );

  useEffect(() => {
    if (editedTooltip) {
      // console.log("Candidate candidateNotes: ", candidateNotes);
      // const recentlyModified = candidateNotes
      //   .filter((item: any) => item.custom_fields.is_edited)  // Only include entries with modified_date
      //   .sort((a: any, b: any) => new Date(b.custom_fields.modified_date).getTime() - new Date(a.custom_fields.modified_date).getTime()); // Sort by latest modification
      //   // .map((item: any) => item.custom_fields.display_name);
      // const displayName = recentlyModified.filter((item: any) => item.custom_fields?.display_name);
      // if (displayName.length > 0) {
      //   setNameTooltip(`Edited by ${displayName[0].custom_fields.edited_by} ${new Date(displayName[0].custom_fields.modified_date).getDate()}`);
      // }
      // console.log("display name: ", recentlyModified.filter((item: any) => item.custom_fields?.display_name)[0]);
    }
  }, [editedTooltip]);

  // useEffect(() => {
  //   if (editedTooltip && candidateNotes) {  // Ensure candidateNotes is not null or undefined
  //     console.log("Candidate candidateNotes: ", candidateNotes);

  //     const recentlyModified = candidateNotes
  //       ?.filter((item: any) => item?.custom_fields?.is_edited)  // Check for undefined properties
  //       .sort(
  //         (a: any, b: any) =>
  //           new Date(b?.custom_fields?.modified_date).getTime() -
  //           new Date(a?.custom_fields?.modified_date).getTime()
  //       ); // Sort by latest modification

  //     if (recentlyModified?.length > 0) {
  //       const displayName = recentlyModified.filter(
  //         (item: any) => item?.custom_fields?.display_name
  //       );

  //       if (displayName?.length > 0) {
  //         setNameTooltip(
  //           `Edited by ${displayName[0]?.custom_fields?.edited_by} ${new Date(displayName[0]?.custom_fields?.modified_date)?.toISOString()
  //             .split("T")[0]}`
  //         );
  //       }
  //     }
  //   }
  // }, [candidateNotes]);


  return (
    <Flex gap={32} className="py-6">
      <Flex className="relative justify-center items-center">
        {/* <Avatar size={110} icon={<img src={profilePic ?? ProfileLogo} alt={name} />} /> */}
        <div className="w-[110px] h-[110px] bg-utility-bluelight rounded-full relative">
          <img
            src={profilePic ?? ProfileLogo}
            alt={name}
            className="object-cover object-center rounded-full"
          />

          {licenses?.length > 0 &&
            licenses.length &&
            licenses.some((license: any) => license.verified) && (
              <Popover content={content} title="Licenses">
                <span
                  className="absolute right-[-10px] top-1/2 w-5 h-5 transform rotate-10"
                >
                  {SvgIcons.verifiedSvg}
                </span>
              </Popover>
            )}
          {npi && (
            <a
              title="NPI Registry"
              style={{ color: "#1890ff", textDecoration: "none" }}
              href={`https://npiregistry.cms.hhs.gov/provider-view/${npi}`}
              target={"_blank"}
              rel="noreferrer"
            >
              <img
                className="absolute right-[-10px] top-1/2 w-5 h-5 transform rotate-10"
                src={npiIcon}
              />
            </a>
          )}
          {/* <Tag
            icon={<CheckCircleFilled size={8} style={{ color: "#17B26A" }} />}
            style={{
              border: "1px solid #D0D5DD",
              backgroundColor: "#FFF",
              color: "#344054",
              borderRadius: "6px",
              padding: "2px 6px",
              fontSize: "12px",
              fontWeight: 500,
              height: "fit-content",
              gap: "4px",
            }}
            className="absolute top-[100px] left-1/2 -translate-x-1/2"
          >
            Contacted
          </Tag> */}
        </div>
      </Flex>
      <Flex className="flex-col justify-center gap-4">
        {editedTooltip ? (
          // <Tooltip
          //   title={toolTipText?.display_name}
          //   color="black"
          //   placement="right"
          //   overlayInnerStyle={{
          //     borderRadius: "8px",
          //     padding: "6px 12px",
          //     fontSize: "12px",
          //   }}
          // >

          <Flex gap={2} wrap="wrap">
            <TooltipWrapper text={toolTipText?.display_name} placement="top">
              <Title4 text={name || "Full Name"} className="text-text-heading font-semibold" />
            </TooltipWrapper>
            <TooltipWrapper text={toolTipText?.title} placement="right">
              <Title4
                text={`/ ${title || "Candidate Title"}`}
                className="text-fonttext-primary font-semibold"
              />
            </TooltipWrapper>
          </Flex>
        ) : (
          <Flex gap={2} wrap="wrap">
            <Title4 text={name || "Full Name"} className="text-text-heading font-semibold" />
            <Title4
              text={`/ ${title || "Candidate Title"}`}
              className="text-fonttext-primary font-semibold"
            />
          </Flex>
        )}

        {editedTooltip ? (
          // <Tooltip
          //   title={toolTipText?.location}
          //   color="black"
          //   placement="right"
          //   overlayInnerStyle={{
          //     borderRadius: "8px",
          //     padding: "6px 12px",
          //     fontSize: "12px",
          //   }}
          // >
          // <TooltipWrapper text={toolTipText?.location} placement="right">
          <div>
            <ExtraSmallTitle
              text={location || "Candidate Location"}
              className="font-medium text-text-secondary"
              tooltipText={toolTipText?.location}
            />
          </div>
          // </TooltipWrapper>
        ) : (
          <div>
            <ExtraSmallTitle
              text={location || "Candidate Location"}
              className="font-medium text-text-secondary"
            />
          </div>
        )}
        {editedTooltip ? (
          // <Tooltip
          //   title={toolTipText?.title}
          //   color="black"
          //   placement="right"
          //   overlayInnerStyle={{
          //     borderRadius: "8px",
          //     padding: "6px 12px",
          //     fontSize: "12px",
          //   }}
          // >
          // <TooltipWrapper text={toolTipText?.title} placement="right">
          <div style={{ marginTop: "-20px" }}>
            <JobTitleList jobTitles={jobTitles} smallText={true} />
          </div>
          // </TooltipWrapper>
          // </Tooltip>
        ) : (
          <JobTitleList jobTitles={jobTitles} smallText={true} />
        )}

      </Flex>
    </Flex>
  );
};

export default CandidateInfoCard;
